import React, { useState } from "react";

import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useNorthbeamMutation } from "@hooks/http";
import {
  type GetCampaign_me_adObject,
  type GetCampaign_me_adObject_labelsDigest,
  type RemoveLabel,
  type RemoveLabelVariables,
} from "@north-beam/nb-client-side";
import { REMOVE_LABEL } from "@pages/objects/label-editor";
import Spinner from "@shared/spinner";

interface Props {
  label: GetCampaign_me_adObject_labelsDigest;
  adObject: GetCampaign_me_adObject;
  isLastRow: boolean;
  onRemoving(): void;
  onRemoved(): Promise<void>;
  onCancel(): void;
}

export const RowToDelete = ({
  label,
  adObject,
  isLastRow,
  onRemoving,
  onRemoved,
  onCancel,
}: Props) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const [loading, setLoading] = useState(false);

  const [removeLabel] = useNorthbeamMutation<RemoveLabel, RemoveLabelVariables>(
    REMOVE_LABEL,
    {
      useCpuIntensive: true,
    },
  );

  return (
    <tr className="h-10 bg-mars-2">
      <td
        colSpan={2}
        className={clsx("px-2 text-xs", {
          "border-b": !isLastRow,
          "norder-b-0": isLastRow,
        })}
      >
        <div className="flex items-center">
          {loading && <Spinner colorClassname="text-mars-1 mx-2" />}
          {!loading && (
            <>
              <button
                className="text-mars+1 font-bold rounded px-3 py-1 mr-2 hover:bg-white"
                onClick={async () => {
                  prettyLogEventPage({
                    domain: "Flyout",
                    action: "onClick",
                    additionalActionInfo: "Flyout breakdown labels delete",
                    data: {
                      pageContext: { id: adObject.id, key: label.key },
                    },
                  });

                  onRemoving();
                  setLoading(true);
                  await removeLabel({
                    variables: { id: adObject.id, key: label.key },
                  });
                  onRemoved();
                }}
              >
                YES, DELETE
              </button>
              <button
                className="text-cosmic font-bold rounded px-3 py-1 hover:bg-white"
                onClick={onCancel}
              >
                CANCEL
              </button>
            </>
          )}
        </div>
      </td>
    </tr>
  );
};
